var hasMilitaryTimeFormat = true;
var Global_RenderedFormTypeId = 0;//TrlObjectTypeId of rendered form

//---------------------------------------------------------
//----------------------Menu Functions --------------------
//---------------------------------------------------------

// detect browser close and naviagtion to other domains
// use beforeunload event together with navigation handlers

// set this to true, if navigation was triggered by one of our page controls
var wasVaildNavigationCall = false;

window.onbeforeunload = function () {
    if (!wasVaildNavigationCall) {
        // implement handlers here
    }
    wasVaildNavigationCall = false;
};

// Attach the event click for all links in the page
$("a").bind("click", function () {
    TryResetMenuTimer('link click');
    wasVaildNavigationCall = true;
});

// Attach the event submit for all forms in the page
//$("form").bind("submit", function () {
//    TryResetMenuTimer('form submit');
//    wasVaildNavigationCall = true;
//});

// Attach the event click for all inputs in the page
$("input[type=submit]").bind("click", function () {
    TryResetMenuTimer('input submit');
    wasVaildNavigationCall = true;
});

// catch key event for:
// a)- backspace; in IE this triggers a back navigation, which is not handled in unload event
// suppress on all controls, which do not allow text modification
// this code is only needed for IE, but there is no need to make it browser specific

// b) activate enter key to trigger primary button click on pages and modal dlgs..
$(document).on('keydown', function (e) {
    var $target = $(e.target || e.srcElement);
    if (e.keyCode == 8) {
        if (!$target.is('textarea,input[type="text"],input[type="password"],input.k-textbox')) {
            e.preventDefault();
        }
        else if ($target.attr("readonly") !== undefined || $target.attr("disabled") !== undefined) {
            e.preventDefault();
        }
    }
	
	// handle "enter" 
    if (e.keyCode == 13) {       
    	// check if popup is on dlg and has prime button -> use this
        var $popUpBtn = $('.popupMessage').siblings('.dialogFooter').find('.btn-primary');   
        if ($popUpBtn != null && $popUpBtn.length == 1 && !$popUpBtn.is(':disabled')) {
    		TriggerPrimeButtonClick($popUpBtn, $target);
    		return false;
    	}else{    		
            var $focusedEl = $(":focus"); // check if any other than prime button has focus- > "click" it
            if($focusedEl.length > 0 && !$focusedEl.is(':disabled') && ($focusedEl.hasClass('btn-tertiary') || $focusedEl.hasClass('btn-secondary')) ){
                TriggerPrimeButtonClick($focusedEl, $target);
            }       
            else {
                var $formBtn = $(".btn-primary");
    		    if ($formBtn.length == 1 && !$formBtn.is(':disabled')) {    			
    			    TriggerPrimeButtonClick($formBtn, $target);
    			    return false;
    		    }
            }
    	}    
	}
});


function TriggerPrimeButtonClick($btn, $target){
	if (!$target.is('textarea')) {
		$btn.click();
		return false;
	}
}


function Logout(reasonId) {
    if (reasonId == null)
        reasonId = 0;

    $("#LogoutReason").val(reasonId);
    $('#logoutForm').submit();
}

// try to reset the menu timer
function TryResetMenuTimer(alertText) {
    try {
        if (ResetMenuTimer && typeof (ResetMenuTimer) == "function") {
            ResetMenuTimer(alertText);
        }
    }
    catch (err) { // ignore error
    }
}

//----------------------------------------------------------------------
// Redirect Functions
//----------------------------------------------------------------------
// Resets the 'isFormModified' flag which was involuntarily set due to the javascript call
function ResetButtonFrame() {
    sessionStorage.isFormModified = false;
}

var isClicked = false;
function RedirectToContentFrameFromReportingGridLink(gridName, controllerName, uniqueGridId, id, url) {
    RedirectToContentFrame(id, url);
}

function RedirectToContentFrame(id, url) {
    if (isClicked == null || isClicked)
        return;

    var obj = $("#" + id);
    if (obj == null || obj.disabled)
        return;

    NavigateAway(url);
}
function RedirectToContentFrameCallback(obj) {
    isClicked = true;
    obj.onclick = disabledLinkClick;
    obj.disabled = true;
    obj.style.cursor = "default";
}
function disabledLinkClick() {
    return false;
}

function NavigateAway(url, menuId, clearSelectedSiteAndPatient) {
    if (clearSelectedSiteAndPatient == null || clearSelectedSiteAndPatient == undefined || typeof (clearSelectedSiteAndPatient) != "boolean")
        clearSelectedSiteAndPatient = false;
    if (menuId != null && menuId != undefined) {
        if (sessionStorage.SelectedMenuItemId != null && sessionStorage.SelectedMenuItemId != undefined && sessionStorage.SelectedMenuItemId != menuId) {
            //remove previous selection
            $("#" + sessionStorage.SelectedMenuItemId).removeClass("active");
        }
        sessionStorage.SelectedMenuItemId = menuId;
        $("#" + sessionStorage.SelectedMenuItemId).addClass("active");
    }
    else {
        sessionStorage.SelectedMenuItemId = null;
    }
    if (clearSelectedSiteAndPatient && typeof (GlobalHeaderLeft_ClearSelectedSite) == "function") {
        GlobalHeaderLeft_ClearSelectedSite(url);
    }
    else {
        NavigateAway_Callback(url);
    }
}

function NavigateAway_Callback(url) {
    url = decodeHtml(url);
    if (sessionStorage.IsFormDirty != 'undefined' && sessionStorage.IsFormDirty != null && JSON.parse(sessionStorage.IsFormDirty)) {
        var ajaxUrl = baseUrl.replace("zzzCONTzzz", "Form").replace("zzzACTzzz", "NavigateAway");

        $.ajax({
            data: { url: url },
            url: ajaxUrl,
            method: "GET",
            success: function (html) {
                ShowModal(html)
            },
            error: function (result) {
                showAlert("Ajax error navigating away", "Error");
            }
        });
    }
    else {
        sessionStorage.IsFormDirty = false;
        if (url.indexOf('replaceDivBody') == 0)
            replaceDivBody(url.substring(14))
        else {
            if (url.indexOf('/ICrf/') > 0)
                Kendo_ShowOrHideLoadingImage("divMain", true);
            Global_RenderedFormTypeId = 0;//reset
            window.location = url;
        }
    }
}

//ajaxUrlTemplate is optional and needed only when "NavigateAway" cannot be found in current controller (must use placeholders "___ACT___" for Action and "___CONT___" for controller)
//ajaxUrlController is optional and needed only when "NavigateAway" cannot be found in current controller
//callBackFunction is function name that will be called and it is always required
//after callBackFunction you can add as many as needed optional parameters for callBackFunction
//!!! Never pass complex objects or arrays as parameters for callBackFunction !!!
function NavigateAwayWithCallBack(ajaxUrlTemplate, ajaxUrlController, callBackFunction) {
    var callBack = callBackFunction + "(";
    for (var i = 3; i < arguments.length; i++) {
        if (typeof(arguments[i]) == "string")
            callBack += "'" + arguments[i] + "',";//only strings should be enclosed with quotes - for null, undefined and boolean, quotes would change the variable type
        else
            callBack += arguments[i] + ",";
    }
    if (callBack.substring(callBack.length - 1, callBack.length) == ",")
        callBack = callBack.substring(0, callBack.length - 1);//remove ','
    callBack += ")";
    return NavigateAwayWithCallBackAndCancelCallBack(callBack, null, ajaxUrlTemplate, ajaxUrlController);
}

//this function accepts callbacks as strings
//ex: 'NavigateAwayOk()', 'NavigateAwayCancel()'
function NavigateAwayWithCallBackAndCancelCallBack(callBack, cancelCallBack, ajaxUrlTemplate, ajaxUrlController) {
    if (sessionStorage.IsFormDirty == 'undefined' || sessionStorage.IsFormDirty == null || !JSON.parse(sessionStorage.IsFormDirty))
        return false;

    var urlLocal = "NavigateAway";
    if (ajaxUrlTemplate != undefined && ajaxUrlController != undefined && ajaxUrlTemplate != null && ajaxUrlController != null)
        urlLocal = ajaxUrlTemplate.replace("___ACT___", "NavigateAway").replace("___CONT___", ajaxUrlController); 

    $.ajax({
        data: { url: '', callBack: callBack, cancelCallBack: cancelCallBack },
        url: urlLocal,
        method: "GET",
        success: function (html) {
            ShowModal(html)
        },
        error: function (result) {
            showAlert("Ajax error navigating away", "Error");
        }
    });

    return true;
}

function decodeHtml(text) {
    return $('<div/>').html(text).text();
}


//----------------------------------------------------------------------
// Functions responding to Grid.cshtml
//----------------------------------------------------------------------

function BaseListView_EnableDisableFooterButtons(gridName, unqRepGridId, controllerName) {
    var hasDeleted = false;
    var hasActive = false;
    var hiddenSysForm = false;

    if (controllerName == "VisitListView") {
        ReportGridAjax_InitiateGetTwoColumnValuesForCheckedActiveCheckboxRows(gridName, controllerName, unqRepGridId, "TrlObjectStateBitMask__x37x_HIDDEN_x37x_", "HiddenSysForm__x37x_HIDDEN_x37x_", function (gridName, response) {
            $.each(response.response, function (index, value) {
                if ((parseInt(value) & 1073741824) > 0)
                    hasDeleted = true;
                else
                    hasActive = true;
            });

            $.each(response.response2, function (index, value) {
                if (value.toLowerCase() == "true") {
                    hiddenSysForm = true;
                    return false;
                }
            });

            if (hasDeleted & hasActive)
                hasDeleted = hasActive = false;
            EnableButtons(hasDeleted, hasActive, hiddenSysForm, response);
        });

    }
    else {
        ReportGridAjax_InitiateGetColumnValuesForCheckedActiveCheckboxRows(gridName, controllerName, unqRepGridId, "TrlObjectStateBitMask__x37x_HIDDEN_x37x_", function (gridName, response) {
            $.each(response, function (index, value) {
                if ((parseInt(value) & 1073741824) > 0)
                    hasDeleted = true;
                else
                    hasActive = true;
            });

            if (hasDeleted & hasActive)
                hasDeleted = hasActive = false;
            EnableButtons(hasDeleted, hasActive, hiddenSysForm, response);
        });
    }
}

function EnableButtons(hasDeleted, hasActive, hiddenSysForm, response) {
    ReportingGrid_EnableButton('btnDelete', hasActive && !hiddenSysForm);
    ReportingGrid_EnableButton('btnUnDelete', hasDeleted && !hiddenSysForm);
    ReportingGrid_EnableButton('btnClear', hasActive);
    ReportingGrid_EnableButton('btnLock', hasActive);
    ReportingGrid_EnableButton('btnUnlock', hasActive);
    ReportingGrid_EnableButton('btnMonitor', hasActive);
    ReportingGrid_EnableButton('btnUnmonitor', hasActive);
    ReportingGrid_EnableButton('btnReview', hasActive);
    ReportingGrid_EnableButton('btnUnreview', hasActive);
    ReportingGrid_EnableButton('btnSign', hasActive);
    ReportingGrid_EnableButton('btnCasebook', hasActive);
    ReportingGrid_EnableButton('btnMovePatients', hasActive);
    ReportingGrid_EnableButton('btnViewSelected', hasActive);
    ReportingGrid_EnableButton('btnPdfReports', hasActive);
    ReportingGrid_EnableButton('btnDatagrid', hasActive);
    if ($("#btnCreateOrEditPatientUser").length > 0)
        ReportingGrid_EnableButton('btnCreateOrEditPatientUser', (response.length == 1));
}

function AddObject(gridName, cntrlName, unqRepGridId, postUrl, ajaxErrorMessage) {
    if (typeof panelSelection_CurrentExpandedInfo_Visits != 'undefined' && panelSelection_CurrentExpandedInfo_Visits != null)
        postUrl = postUrl.replace('000visit000', panelSelection_CurrentExpandedInfo_Visits.visitId);

    var request = $.ajax({
        url: postUrl,
        method: "POST",
        success: function (response) {
            if (AjaxResult_CommonResultHandled(response))
                return;
            if (response && response.result == 'Error')
                showError(response.message, "gridsysmsg");
            else if (response && response.url != null)
                window.location = response.url;
            else
                ShowModal(response, true);
        },
        error: function (response) {
            ReportGridAjax_ErrorHandler(ajaxErrorMessage, response);
        }
    });
}

function AddObjectFromNavigation(ctrlName, postUrl, ajaxErrorMessage) {
    if (NavigateAwayWithCallBack(null, null, 'AddObjectFromNavigation', ctrlName, postUrl))
        return;

    AddObject(null, ctrlName, null, postUrl, ajaxErrorMessage);
}

function ViewSelected_ExecuteViewSelected(gridName, controllerName, uniqueGridId, buttonId, actionName) {
    var arrCheckedIds = ReportingGrid_GetCheckedIdsArray(gridName);
    if (!Array.isArray(arrCheckedIds) || arrCheckedIds.length < 1)
        return;

    //if not, get the data from server
    //Kendo_ShowOrHideLoadingImage("div...", true);

    var currentPathControllerAction = undefined;
    if ($(':hidden#RepGridUrlBuilder').length > 0)
        currentPathControllerAction = $(':hidden#RepGridUrlBuilder').val();
    if (currentPathControllerAction == undefined || currentPathControllerAction == "") {
        ReportGridAjax_ErrorHandler("View Selected failed / Path to Ajax URL is undefined /");
        return;
    }

    var ajaxUrl = currentPathControllerAction.replace("zzzACTzzz", actionName).replace("zzzCONTzzz", controllerName);

    var request = $.ajax({
        url: ajaxUrl,
        method: "POST",
        data: {
            uniqueReportingGridId: uniqueGridId,
            doFilter: true,
            checkedActiveCheckboxIds: arrCheckedIds
        },
        success: function (res) {
            if (AjaxResult_CommonResultHandled(res))
                return;
            if (res.result == "OK") {
                window.location.href = currentPathControllerAction.replace("zzzCONTzzz", "PatientListView").replace("zzzACTzzz", "SelectPatient") + "?ngrd=3";
            }
            //alert(res);
            //Kendo_ShowOrHideLoadingImage("div...", false);
        },
        error: function (result) {
            //Kendo_ShowOrHideLoadingImage("div...", false);
            ReportGridAjax_ErrorHandler("View Selected failed", result);
        }
    });
}

function updateAll(gridName, cntrlName, unqRepGridId, confirmMessage, confirmationTitle, ajaxErrorMessage, postUrl, secAreaId, trlObjectType, trlObjectPatientId, trlObjectPatientSystemFormId, patientCaption, tot, isDynMon) {
    if (isDynMon == '') {
        updateAllInternal(gridName, cntrlName, unqRepGridId, confirmMessage, confirmationTitle, ajaxErrorMessage, postUrl, secAreaId, trlObjectType, trlObjectPatientId, trlObjectPatientSystemFormId, patientCaption, tot);
    }
    else
    {
        ReportGridAjax_InitiateGetColumnValuesForCheckedActiveCheckboxRows(gridName, cntrlName, unqRepGridId, isDynMon, function (gridName, response) {
            if (response.toString().toLowerCase().indexOf('true') > -1) {
                postUrl = postUrl.toLowerCase().replace('monitor', 'MonitorAllSelection');
                openMonitorAllSelectionDlg(gridName, cntrlName, unqRepGridId, confirmMessage, confirmationTitle, ajaxErrorMessage, postUrl, secAreaId, trlObjectType, trlObjectPatientId, trlObjectPatientSystemFormId, patientCaption);
            }
            else {
                updateAllInternal(gridName, cntrlName, unqRepGridId, confirmMessage, confirmationTitle, ajaxErrorMessage, postUrl, secAreaId, trlObjectType, trlObjectPatientId, trlObjectPatientSystemFormId, patientCaption, tot);
            }
        });
    }

}

function updateAllInternal(gridName, cntrlName, unqRepGridId, confirmMessage, confirmationTitle, ajaxErrorMessage, postUrl, secAreaId, trlObjectType, trlObjectPatientId, trlObjectPatientSystemFormId, patientCaption, tot) {
    showConfirmation(confirmMessage, function () {
        Kendo_ShowOrHideLoadingImage("divMain", true);
        var postData = { sca: secAreaId, tp: trlObjectType, ids: ReportingGrid_GetCheckedIdsArray(gridName, true) };
        $.ajax({
            url: postUrl,
            method: "POST",
            data: postData,
            success: function (result) {
                Kendo_ShowOrHideLoadingImage("divMain", false);
                ShowModal(result, true);
                var isPanelVisible = ($("#divPanelSelection").length > 0 && $("#divPanelSelection").is(":visible"));
                if (isPanelVisible) {
                    GlobalHeaderLeft_RefreshPatient(trlObjectPatientId, trlObjectPatientSystemFormId, tot, patientCaption);
                }
                else {
                    ReportingGrid_ResetCacheAndReloadGrid(gridName, cntrlName, unqRepGridId);
                }
                ReportingGrid_AcitveCheckboxReset(gridName, unqRepGridId, cntrlName);
            },
            error: function (result) {
                Kendo_ShowOrHideLoadingImage("divMain", false);
                ReportGridAjax_ErrorHandler(ajaxErrorMessage, result);
            }
        });
    }, confirmationTitle);
}

function openMonitorAllSelectionDlg(gridName, cntrlName, unqRepGridId, confirmMessage, confirmationTitle, ajaxErrorMessage, postUrl, secAreaId, trlObjectType, trlObjectPatientId, trlObjectPatientSystemFormId, patientCaption) {
    showConfirmation(confirmMessage, function () {
        var postData = { gn: gridName, uid: unqRepGridId, cn: cntrlName, sca: secAreaId, tp: trlObjectType, pid: trlObjectPatientId, psid: trlObjectPatientSystemFormId, pc: patientCaption };
        var request = $.ajax({
            url: postUrl,
            data: postData,
            method: "GET",
            success: function (result) {
                ShowModal(result, true);
            },
            error: function (result) {
                ReportGridAjax_ErrorHandler(ajaxErrorMessage, result);
            }
        });
    }, confirmationTitle);
}

function GetNavPredefCondValsAndSetStorage(trlObjectPatientId, trlObjectPatientSystemFormId, patientCaption) {
    var predf = "";
    var allVisitsGridDisplayed = ($("#divBodyRender").length > 0 && $("#divBodyRender").find("#divGlobalNavigation_AllVisitsGrid").length > 0);
    var allFormsGridDisplayed = ($("#divBodyRender").length > 0 && $("#divBodyRender").find("#divGlobalNavigation_AllFormsGrid").length > 0);
    localStorage.setItem("PanelSelection_isPanelExpanded", undefined);
    localStorage.setItem("PanelSelection_allVisitsGridDisplayed", allVisitsGridDisplayed);
    localStorage.setItem("PanelSelection_allFormsGridDisplayed", allFormsGridDisplayed);
    localStorage.setItem("PanelSelection_trlObjectPatientId", trlObjectPatientId);
    localStorage.setItem("PanelSelection_trlObjectPatientSystemFormId", trlObjectPatientSystemFormId);
    localStorage.setItem("PanelSelection_patientCaption", patientCaption);
    var isPanelVisible = ($("#divPanelSelection").length > 0 && $("#divPanelSelection").is(":visible"));
    if (isPanelVisible &&
        (typeof (panelSelection_CurrentExpandedInfo_Visits) != "undefined" && typeof (panelSelection_CurrentExpandedInfo_Forms) != "undefined")) {
        if (typeof (PanelSelection_IsPanelExpanded) == "function") {
            var isPanelExpanded = PanelSelection_IsPanelExpanded();
            localStorage.setItem("PanelSelection_isPanelExpanded", isPanelExpanded);
        }
        var isFormsTabActive = ($("#FormsTabId").hasClass("active-tab"));
        var isVisitsTabContentVisitsVisible = !isFormsTabActive && (panelSelection_CurrentExpandedInfo_Visits == null);
        var isFormsTabContentProFormsVisible = isFormsTabActive && (panelSelection_CurrentExpandedInfo_Forms == null);
        var isVisitsTabContentFormsVisible = !isFormsTabActive && (panelSelection_CurrentExpandedInfo_Visits != null);
        var isFormsTabContentProFormsFormsVisitVisible = isFormsTabActive && (panelSelection_CurrentExpandedInfo_Forms != null);
        var expandedVisitId = 0;
        var expandedProFormId = 0;
        if (panelSelection_CurrentExpandedInfo_Visits != null || panelSelection_CurrentExpandedInfo_Forms != null) {
            if (panelSelection_CurrentExpandedInfo_Visits != null)
                expandedVisitId = panelSelection_CurrentExpandedInfo_Visits.visitId;
            if (panelSelection_CurrentExpandedInfo_Forms != null)
                expandedProFormId = panelSelection_CurrentExpandedInfo_Forms.proFormId;
        }
        predf = (isFormsTabActive ? '1' : '0') +
            (isVisitsTabContentVisitsVisible ? '1' : '0') +
            (isFormsTabContentProFormsVisible ? '1' : '0') +
            (isVisitsTabContentFormsVisible ? '1' : '0') +
            (isFormsTabContentProFormsFormsVisitVisible ? '1' : '0') +
            '_' + expandedVisitId + '_' + expandedProFormId;
    }
    return predf;
}

function signAll(gridName, cntrlName, unqRepGridId, confirmMessage, confirmationTitle, ajaxErrorMessage, postUrl, secAreaId, trlObjectType, trlObjectPatientId, trlObjectPatientSystemFormId, patientCaption) {
    var ids = ReportingGrid_GetCheckedIdsArray(gridName, true).join(",");
    var index = popupWindosIds.indexOf("popupWindow");
    if (index !== -1)
        popupWindosIds.splice(index, 1);
    var predf = GetNavPredefCondValsAndSetStorage(trlObjectPatientId, trlObjectPatientSystemFormId, patientCaption);  
    showConfirmation(confirmMessage, function () {
        var postData = { gn: gridName, uid: unqRepGridId, cn: cntrlName, sca: secAreaId, tp: trlObjectType, pid: trlObjectPatientId, psid: trlObjectPatientSystemFormId, pc: patientCaption, ids: ids, predf: predf };
        $.ajax({
            url: postUrl,
            method: "GET",
            data: postData,
            success: function (result) {
                ShowModal(result);
            },
            error: function (result) {
                ReportGridAjax_ErrorHandler(ajaxErrorMessage, result);
            }
        });
    }, confirmationTitle);
}

function CommitSign(timeoutInterval) {
    // Reset the Sign Password timeout
    ResetTimeout(timeoutInterval);
}

function openChangeNoteDlg(gridName, cntrlName, unqRepGridId, confirmMessage, confirmationTitle, ajaxErrorMessage, postUrl, secAreaId, trlObjectType, secEventId, trlObjectPatientId, trlObjectPatientSystemFormId, patientCaption) {
    showConfirmation(confirmMessage, function () {
        var postData = { gn: gridName, uid: unqRepGridId, cn: cntrlName, sca: secAreaId, tp: trlObjectType, sid: secEventId, pid: trlObjectPatientId, psid: trlObjectPatientSystemFormId, pc: patientCaption };
        var request = $.ajax({
            url: postUrl,
            data: postData,
            method: "GET",
            success: function (result) {
                ShowModal(result);
            },
            error: function (result) {
                ReportGridAjax_ErrorHandler(ajaxErrorMessage, result);
            }
        });
    }, confirmationTitle);
}

//if you are adding parameters to this function, make sure to find where it is called, and provide params there also!
function openChangeNoteDlgFromNavigation(ctrlName, confirmMessage, confirmationTitle, postUrl, ajaxErrorMessage) {
    if (NavigateAwayWithCallBack(null, null, 'openChangeNoteDlgFromNavigation', ctrlName, confirmMessage, confirmationTitle, postUrl, ajaxErrorMessage))
        return;
    showConfirmation(confirmMessage, function () {
        var request = $.ajax({
            url: postUrl,
            method: "GET",
            success: function (result) { 
                if (AjaxResult_CommonResultHandled(result))
                    return;
                ShowModal(result);
            },
            error: function (result) {
                ReportGridAjax_ErrorHandler(ajaxErrorMessage, result);
            }
        });
    }, confirmationTitle);
}

function redirectToCasebook(gridName, cntrlName, unqRepGridId, url, siteCaption, patientsFromDifferentSitesError) {
    ReportGridAjax_InitiateGetColumnValuesForCheckedActiveCheckboxRows(gridName, cntrlName, unqRepGridId, siteCaption, function (gridName, response) {
        if (!IsSameSite(response)) {
            ReportingGrid_AcitveCheckboxReset(gridName, unqRepGridId, cntrlName);
            showError(patientsFromDifferentSitesError, "gridsysmsg");
        }
        else
            window.location = url + '&tosid=' + response[0] + '&ids=' + ReportingGrid_GetCheckedIdsArray(gridName, true)
    });
}

function redirectToPdfReports(gridName, cntrlName, unqRepGridId, redirect, url, toid, topid, selectOneOnly) {
    if (redirect) {
        window.location = url + '&partialView=false&toid=' + ReportingGrid_GetCheckedIdsArray(gridName, true) + '&p=' + topid;
    }
    else {
        var postUrl = url + '&partialView=true&toid=' + ReportingGrid_GetCheckedIdsArray(gridName, true) + '&p=' + topid;
        replaceDivBody(postUrl);
    }
}

function openDatagrid(gridName, cntrlName, unqRepGridId, redirect, url, ajaxErrorMessage) {
    if (redirect){
        window.location = url + '&partialView=false&ids=' + ReportingGrid_GetCheckedIdsArray(gridName, true);
    }
    else{
        var postUrl = url + '&partialView=true&ids=' + ReportingGrid_GetCheckedIdsArray(gridName, true);        
        replaceDivBody(postUrl);
    }
}

function PanelSelection_ResetRenderedForm() {
    if (typeof panelSelection_CurrentExpandedInfo_RenderedForm != "undefined")
        panelSelection_CurrentExpandedInfo_RenderedForm = null;
    if (typeof panelSelection_RestoreNextPatient != "undefined" && panelSelection_RestoreNextPatient != null) {
        if (typeof panelSelection_RestoreNextPatient.RenderedProFormId != "undefined") 
            panelSelection_RestoreNextPatient.RenderedProFormId = 0;
    }
    if (typeof Global_RenderedFormTypeId != "undefined" && typeof (Setup_SysFormsGlobalHeaderLinks) == "function") {
        Global_RenderedFormTypeId = 0;
        Setup_SysFormsGlobalHeaderLinks();
    }
}

function replaceDivBody(url){
    Kendo_ShowOrHideLoadingImage("divMain", true);
    $.ajax({
            url: url,
            method: "GET",
            success: function (result) { 
                PanelSelection_ResetRenderedForm();//we don't know what will be rendered in divBodyRender - if form, we'll set the ID on callback
                if ($(result).find("#divBodyRender").length > 0)
                    result = $(result).find("#divBodyRender");
                $("#divBodyRender").html(result);
                if (typeof (PanelSelection_ShowOrHideActionButtons) == "function")
                    PanelSelection_ShowOrHideActionButtons();
                Kendo_ShowOrHideLoadingImage("divMain", false);
            },
            error: function (result) {
                Kendo_ShowOrHideLoadingImage("divMain", false);
                ReportGridAjax_ErrorHandler(ajaxErrorMessage, result);
            }
        });
}

function CreateOrEditPatientUser(gridName, cntrlName, unqRepGridId, postUrl, patientUserIdColumn, patientCaptionColumn, userNameColumn, trlObjectPatientIdColumn, createUserTitle, editUserTitle, failMessage) {
    //alert("gridName: " + gridName + "; cntrlName: " + cntrlName + "; unqRepGridId: " + unqRepGridId + "; postUrl: " + postUrl + "; patientUserIdColumn: " + patientUserIdColumn)

    var ajaxUrl = postUrl.replace("___ACT___", "AddOrEditPatientUser").replace("___CONT___", "User");

    ReportGridAjax_InitiateGetColumnValuesForCheckedActiveCheckboxRows(gridName, cntrlName, unqRepGridId, patientUserIdColumn, function (gridName, response) {
        var patientUserId = 0;
        if (response.length > 0 && !isNaN(response[0]))
            patientUserId = parseInt(response[0]);

        if (patientUserId == 0) {
            ReportGridAjax_InitiateGetColumnValuesForCheckedActiveCheckboxRows(gridName, cntrlName, unqRepGridId, patientCaptionColumn, function (gridName, response) {
                var patientCaption = "";
                if (response && response.length > 0)
                    patientCaption = response[0];


                ReportGridAjax_InitiateGetColumnValuesForCheckedActiveCheckboxRows(gridName, cntrlName, unqRepGridId, trlObjectPatientIdColumn, function (gridName, response) {
                    var patientId = 0;
                    if (response && response.length > 0 && !isNaN(response[0]))
                        patientId = parseInt(response[0]);
                    //divMain is used here only to show processing image
                    CreateOrEditPatientUser_AjaxGet(patientUserId, ajaxUrl, CreateOrEditPatientUser_AjaxGet_Callback, failMessage, "divMain", createUserTitle, editUserTitle, gridName, unqRepGridId, patientCaption, patientId, cntrlName);
                });
            });
        }
        else {
            ReportGridAjax_InitiateGetColumnValuesForCheckedActiveCheckboxRows(gridName, cntrlName, unqRepGridId, userNameColumn, function (gridName, response) {
                var userName = "";
                if (response && response.length > 0)
                    userName = response[0];
                //divMain is used here only to show processing image
                CreateOrEditPatientUser_AjaxGet(patientUserId, ajaxUrl, CreateOrEditPatientUser_AjaxGet_Callback, failMessage, "divMain", createUserTitle, editUserTitle, gridName, unqRepGridId, userName, 0, cntrlName);
            });
        }
    });
}

function CreateOrEditPatientUser_AjaxGet(patientUserId, ajaxUrl, callbackSuccess, failMessage, divLoading, createUserTitle, editUserTitle, gridName, unqRepGridId, patientUserNameOrCaption, trlObjectPatientId, gridCntrlName) {
    //trlObjectPatientId is needed only when creating a new user
    Kendo_ShowOrHideLoadingImage(divLoading, true);
    var obData = { patientUserId: patientUserId, patientUserNameOrCaption: patientUserNameOrCaption, gridName: gridName, gridId: unqRepGridId, gridController: gridCntrlName, trlObjectPatientId: trlObjectPatientId };

    var request = $.ajax({
        url: ajaxUrl,
        method: "GET",
        data: obData,
        success: function (data) {
            Kendo_ShowOrHideLoadingImage(divLoading, false);
            if (callbackSuccess)
                callbackSuccess(data, (patientUserId == 0) ? createUserTitle : editUserTitle, gridName, unqRepGridId);
        },
        error: function (result) {
            Kendo_ShowOrHideLoadingImage(divLoading, false);
            if (failMessage != undefined && failMessage != "")
                ReportGridAjax_ErrorHandler(failMessage, result);
        }
    });
}


function CreateOrEditPatientUser_AjaxGet_Callback(htmlData, dialogTitle, gridName, unqRepGridId) {
    var uniquePopUpWindow = $("<div id='userAddOrEdit' class='popupWindow popupWindowAddModifyPatientUser'></div>")
             .appendTo("body")
             .kendoWindow({
                 modal: true,
                 resizable: true,
                 title: dialogTitle,
                 minWidth: "300px",
                 minHeight: "300px",
                 visible: false,
                 close: function (e) {
                     this.destroy();
                 },
                 refresh: function () {
                     $(".close-button").click(function () {
                         AddOrEditPatientUser_Close();
                         //this.close();
                     });

                     if (centerWindow)
                         this.center();
                 }
             }).data('kendoWindow').content(htmlData);

    uniquePopUpWindow.center().open();
    $("#userAddOrEdit").parent().addClass("popupWindowParent").find('.k-i-close').first().addClass('fa fa-times-circle tmfatimescircle').text("");
}


function movePatients(gridName, cntrlName, unqRepGridId, confirmMessage, confirmationTitle, ajaxErrorMessage, postUrl, secAreaId, trlObjectType, siteCaption, patientsFromDifferentSitesError) {
    ReportGridAjax_InitiateGetColumnValuesForCheckedActiveCheckboxRows(gridName, cntrlName, unqRepGridId, siteCaption, function (gridName, response) {
        if (!IsSameSite(response)) {
            ReportingGrid_AcitveCheckboxReset(gridName, unqRepGridId, cntrlName);
            showError(patientsFromDifferentSitesError, "gridsysmsg");
        }
        else {
            showConfirmation(confirmMessage, function () {
                var postData = { gn: gridName, uid: unqRepGridId, cn: cntrlName, sca: secAreaId, tp: trlObjectType, tsid: response[0] };
                $.ajax({
                    url: postUrl,
                    method: "POST",
                    data: postData,
                    success: function (result) {
                        ShowModal(result);
                    },
                    error: function (result) {
                        ReportGridAjax_ErrorHandler(ajaxErrorMessage, result);
                    }
                });
            }, confirmationTitle);
        }
    });
}

function IsSameSite(sitesArray) {
    var sameSite = true;
    var site = sitesArray[0];
    $.each(sitesArray, function (index, value) {
        if (value != site) {
            sameSite = false;
            return;
        }
    });
    return sameSite;
}

function AssignPatientFormDirection(direction) {
    var hiddenField = $("#patFormDirection");
    if (hiddenField != null)
        hiddenField.value = direction;
}

function ClearPatientEntrySubMenu() {
    var obj = $("#subMenuDiv")
    if (obj != null)
        obj.innerHTML = "&nbsp";
}

//----------------------------------------------------------------------
// Functions accessing MenuFrame objects
//----------------------------------------------------------------------

//// Retrieve the saved Web location
function GetLocation() {
    return sessionStorage.urlRef;
}

// Save the 'url' Web location for future reference
function SaveLocation(url) {
    sessionStorage.urlRef = url;
}

//function GoToReferrer() {
//    var paramValue = GetLocation();
//    var loc = $(location).attr('href');
//    if (loc.toLowerCase().indexOf("mainform.aspx") != -1 && loc.toLowerCase().indexOf("t=6") != -1)
//        NavigateAway(loc); //this will reload home page with default report - used only when form is opened on dashboard using url from report and then "cancel" is clicked
//    else {
//        if (loc == paramValue || paramValue == "")
//            paramValue = GetPrevLocation()
//        window.location = paramValue;
//    }

//    if (GetLocation().indexOf("ShowDataGrid") > -1)
//        SaveLocation('');
//}

//// Saves the 'url' web location of previous(navigated from) page.
//function SaveCurrentLocation(url) {
//    sessionStorage.urlPrevRef = url;
//}

//// Get the saved Web location of Previous 'Navigated from ' page
//function GetPrevLocation() {
//    return sessionStorage.urlPrevRef;
//}

////Go to Previous 'Navigated from' page
//function GoToPrevReferrer() {
//    var paramValue = GetPrevLocation();
//    window.location = paramValue;
//}

//// Save the 'url' Web location for future reference
//function SaveTMServerLocation(url) {
//    sessionStorage.TMServerLocation = url;
//}

//// Save the 'currentUrl' Web location for future reference
//function GetTMServerLocation() {
//    return sessionStorage.TMServerLocation;
//}

// Save location and append a parameter indicating return
function SaveLocationAppendReturnFlag(url) {
    if (url.indexOf('ret=1') < 0) {
        if (url.indexOf('?') > 0)
            url += '&ret=1';
        else
            url += '?ret=1';
    }
    SaveLocation(url);
}

// Checks if the system is logged out
function IsLogout() {
    return sessionStorage.isSystemLoggedOut;
}

//----------------------------------------------------------------------
// date and Help Functions
//----------------------------------------------------------------------
function GetCurrentTimeToTimer(dt) {
    try {
        // Get date
        var fDate = GetFormattedDate(dt, "YMD");

        // Get time
        var hh = dt.getHours();
        var mm = dt.getMinutes();
        var ss = dt.getSeconds();
        var sfx = "";

        // TODO: should check whether to format with AM/PM if (isAM != null)
        if (!hasMilitaryTimeFormat) {
            if (hh > 11) {
                hh -= 12;
                sfx = "PM";
            }
            else
                sfx = "AM";
            if (hh == 0)
                hh = 12;
        }

        var res = FormatDD(hh);
        res = res + ':' + FormatDD(mm);
        res = res + ':' + FormatDD(ss);
        fDate = fDate + " " + res + " " + sfx;
        return fDate;
    }
    catch (ex) {
        return dt.toUTCString();
    }
}

function SetHelpTopicId(helpIdx) {
    helpIdx = helpIdx;
}

function SetHelpRoleId(helpRoleId) {
    helpRoleIdx = helpRoleId;
}

// for textarea we need a similar limit for maxlength as textbox has
function LimitTextAreaLen(obj) {
    var maxlen = obj.getAttribute("maxLength");
    // additional check added for IE10
    // "maxLength" does not show in the obj collection through getAttribute or casting to jQuery for .attr
    // accessing the collection directly until research can determine the proper way to handle IE10
    if (maxlen == null)
        maxlen = obj.attributes("maxLength").value;
    if (maxlen != null && maxlen != "") {
        var mlength = parseInt(maxlen, 10);
        if (obj.value.length > mlength)
            obj.value = obj.value.substring(0, mlength)
    }
}

//prepends with leading 0
function FormatDD(d) {
    if (d == '0' || d == '1' || d == '2' || d == '3' || d == '4' || d == '5' || d == '6' || d == '7' || d == '8' || d == '9')
        return '0' + d;

    return d;
}
function trim_x(str) { return str.replace(/^\s+|\s+$/g, '').replace(/\s/, 'x'); };

// Backspace navigation can cause problems on certain pages - but needs to be allowed if it was pressed in a text field or area
function AvoidBackspaceNavigation(e) {

    var theEvent = window.event || arguments[0]; // window.event is for IE arguments[0] is for FF
    var kc = theEvent.keyCode;

    if (window.event)
        e = window.event;

    var theSrcElement = e.srcElement ? e.srcElement : e.target; // e.target is for FF
    var t = theSrcElement.type;

    var shouldNotBlock = (kc != 8 && kc != 13) || (t == 'text' && kc != 13) || (t == 'textarea') || (t == 'submit' && kc == 13);

    if (e.preventDefault && !shouldNotBlock) // FF
        e.preventDefault();
    else
        return shouldNotBlock;  // IE
}

function GridCreated(sender, args) {
    var scrollArea = sender.GridDataDiv;
    var dataHeight = sender.get_masterTableView().get_element().clientHeight;
    if (dataHeight < 350) {
        scrollArea.style.height = dataHeight + "px";
    }
}

// rebinds the datagrid which has a query link. The link should open the MsgNotes.aspx
// in editable single query mode wherein the user can add response to the open query. This method
// provides means to refresh the grid with the updated query
function UpdateGridWithLastQueryResponse() {
    var currentForm = document.getElementsByTagName('form')[0];
    var updateTextBox = $("#ForceUpdateGrid");
    if (updateTextBox != null)
        updateTextBox.val(1);
    currentForm.submit();
}

//----------------------------------------------------------------------
// Redirection of 'Enter' keypress to an event
//----------------------------------------------------------------------
//function TextBoxKeyPress(e, id) {
//    var evt = e ? e : window.event;
//    var control = document.getElementById(id);
//    if (control) {
//        if (evt.keyCode == 13) {
//            control.click();
//            return false;
//        }
//    }
//}

// function to convert string "true" or "false" to boolean
function returnBoolean(value) {
    if (value === true || value.toString().toLowerCase() == 'true')
        return true;
    if (value === false || value.toString().toLowerCase() == 'false')
        return false;
    return false;
}

// HTML encode & decode support -> easy methods to invert Server-side HttpUtility.HtmlEncode and HttpUtility.HtmlDecode methods
function HtmlEncode(value) {
    //create a in-memory div, set it's inner text(which jQuery automatically encodes)
    //then grab the encoded contents back out.  The div never exists on the page.
    return $('<div/>').text(value).html();
}

function HtmlDecode(value) {
    return $('<div/>').html(value).text();
}

// check that text does not contain any undesired HTML tags
function ValidateNoHtml(text) {
    return !text.match(/<\/*[a-z][^>]+?>/gi);
}

// ensure all  buttons with attribute equalwidth='true' have same (max) width
function EqualButtonsWidth() {
    var allWidth = 0;
    $("[equalwidth='true']").each(function () {
        if ($(this).width() > allWidth)
            allWidth = $(this).width();
    });
    $("[equalwidth='true']").each(function () {
        $(this).width(allWidth);
    });
}

//// show animated loader on screen
//function ShowLoading() {
//    if ($(".se-pre-con").length)
//        $(".se-pre-con").fadeIn("5");

//    return false;
//}

//// continue only if jquery is not loaded
//if (window.jQuery) {
//    $(window).load(function () {
//        // Add animated loader div to the begining of the body element
//        if (!$(".se-pre-con").length)
//            $(document.body).prepend('<div class="se-pre-con"></div>');

//        // Hide animated loader off screen
//        $(".se-pre-con").fadeOut("5");
//    });

//    // show animated loader when user click on any url with MainFormBig css class
//    $("body").on("click", ".MainFormBig", function () {
//        ShowLoading();
//    });

//    // show animated loader when user click on any url with MainFormBig css class
//    $("body").on("click", ".buttonaa", function () {
//        ShowLoading();
//    });
//}

function getPageName(url) {
    var index = url.lastIndexOf("/") + 1;
    var filename = url.substr(index);
    return filename;
}

function ClearSessionStorage() {
    sessionStorage.clear();
}

function CloseModal(uniquePopupId) {
    if (uniquePopupId != null && uniquePopupId != undefined && uniquePopupId.length === 0)
        uniquePopupId = "popupWindow";

    if ($("#" + uniquePopupId).length > 0) {
        var currenModalWindow = $("#" + uniquePopupId).data("kendoWindow");
        currenModalWindow.close();
        currenModalWindow.destroy(); // destroy method tries to remove Dom elements inside the modal. In case of ListBox, kendo's modal instance not able to find ListBox reference and hence causing removeData of null error.
    }
    //Remove the Id from the list of popupWindosIds
    popupWindosIds.splice($.inArray(uniquePopupId, popupWindosIds), 1);
}

function CloseModelPopup() {
    CloseModal("popupWindow");
}

var popUpWindow;
//List of all modal popups ids created
var popupWindosIds = [];

function showInModal(surl, useDefaultForMinMaxHeight) {
    var request = $.ajax({
        url: surl,
        method: "GET",
        success: function (html) {          
            ShowModal(html, true, false, null, useDefaultForMinMaxHeight);
            ReapplyValidatorsOnAddingPartialView();
        }
    });
}

function ShowModal(html, isResizable, hideTitle, nonCenteredWindowProperties, useDefaultForMinMaxHeight, hideActions, onActvateCallback,
    useReportDefaultsWhenHeightIsAuto) {
    if (isResizable == null || isResizable == undefined || typeof (isResizable) != "boolean")
        isResizable = false;
    if (useDefaultForMinMaxHeight == null || useDefaultForMinMaxHeight == undefined || typeof (useDefaultForMinMaxHeight) != "boolean")
        useDefaultForMinMaxHeight = false;
    if (useReportDefaultsWhenHeightIsAuto == null || useReportDefaultsWhenHeightIsAuto == undefined || typeof (useReportDefaultsWhenHeightIsAuto) != "boolean")
        useReportDefaultsWhenHeightIsAuto = false;
    if (hideTitle == null || hideTitle == undefined || typeof (hideTitle) != "boolean")
        hideTitle = false;
    if (hideActions == null || hideActions == undefined || typeof (hideActions) != "boolean")
        hideActions = false;
    var centerWindow = true;
    if (nonCenteredWindowProperties != null && nonCenteredWindowProperties != undefined && typeof (nonCenteredWindowProperties) == "object")
        centerWindow = false;

    var dialogTitle = hideTitle ? false : $(html).find(".dialogOptions").attr("title");

    var width = $(html).find(".dialogOptions").attr("width");
    if (width == null)
        width = GetPopUpWidth();
    var height = $(html).find(".dialogOptions").attr("height");
    if (height == null)
        height = "auto";
    if (!centerWindow && nonCenteredWindowProperties.width != null)
        width = nonCenteredWindowProperties.width;
    var minwidth = $(html).find(".dialogOptions").attr("minwidth");
    if (minwidth == null)
        minwidth = width;
    var minH = height;
    var maxH = height;
    if (useDefaultForMinMaxHeight) {
        minH = 50;//kendo default
        maxH = Infinity;//kendo default
    }
    if (!useDefaultForMinMaxHeight && useReportDefaultsWhenHeightIsAuto && height == "auto") {
        minH = 160;
        maxH = 640;
    }

    //Id of the ModalPopup, if the client not provide it, then use the default one = "popupWindow"
    var uniquePopupId = $(html).find(".dialogOptions").attr("uniquePopupId");
    if (uniquePopupId == null)
        uniquePopupId = "popupWindow";//Default ModalPopup Name
    
    if ($.inArray(uniquePopupId, popupWindosIds) >= 0 ) {
        console.log("Already exists a ModalPopup element with the id =" + uniquePopupId);
        //Only continue if the uniquePopupId is the default value
        if (uniquePopupId != "popupWindow")
            return;
    }
    else {
        //Adding the Id to the list if it not exists
        popupWindosIds.push(uniquePopupId);
    }

    var uniquePopUpWindow = $("<div id='" + uniquePopupId + "' class='popupWindow col-xs-12 col-md-12'></div>")
      .appendTo("body")
      .kendoWindow({
          width: width,
          minWidth: minwidth,
          modal: true,
          height: height,
          minHeight: minH,
          maxHeight: maxH,
          resizable: isResizable,
          title: dialogTitle,
          visible: false,
          close: function (e) {
              //TryResetMenuTimer('ShowModal close');
              DestroyKendoWidgets();//Manually destroying Kendo widget here.
              //Remove the Id from the list of popupWindosIds
              popupWindosIds.splice($.inArray(uniquePopupId, popupWindosIds), 1);
              this.destroy();// destroy method tries to remove Dom elements inside the modal. In case of ListBox, kendo's modal instance not able to find ListBox reference and hence causing removeData of null error.

          },
          refresh: function () {
              //To ensure that keeps height and close event work afted a refresh
              var windowHeight = $(window).height() * 0.9;
              if ($('.popupMessage').height() > windowHeight) {
                  $('.popupMessage').height(windowHeight - ($('.dialogFooter').height() + $('.dialogOptions').height()));
              }

              $(".close-button").click(function () {
                  CloseModal(uniquePopupId);
              });

              if (centerWindow)
                  this.center();
          }
      }).data('kendoWindow').content(html);

    if (centerWindow)
        uniquePopUpWindow.center().open();
    else {
        uniquePopUpWindow.bind("open", function (e) {
            this.wrapper.css({ top: nonCenteredWindowProperties.top, left: nonCenteredWindowProperties.left });
        });
        uniquePopUpWindow.open();
    }

    if (!hideTitle && !hideActions)
        $("#" + uniquePopupId).parent().addClass("popupWindowParent").find('.k-i-close').first().addClass('fa fa-times-circle tmfatimescircle').text("");
    else if (!hideTitle && hideActions)
        $("#" + uniquePopupId).parent().addClass("popupWindowParent").find('.k-window-actions').first().hide();
    

    if (isResizable) {
        uniquePopUpWindow.bind("resize", function (e) {
            Popup_Resize(e, uniquePopUpWindow, false, centerWindow);
        });
        uniquePopUpWindow.bind("activate", function (e) {
            Popup_Activate(e, uniquePopUpWindow, centerWindow, onActvateCallback);
        });
    }

    $(".close-button").click(function () {
        //TryResetMenuTimer('ShowModal closebutton');
        CloseModal(uniquePopupId);
    });
    var windowHeight = $(window).height() * 0.9;
    if ($('.popupMessage').height() > windowHeight) {
        $('.popupMessage').height(windowHeight - ($('.dialogFooter').height() + $('.dialogOptions').height()));
    }

    if (centerWindow)
        uniquePopUpWindow.center();

    popUpWindow = uniquePopUpWindow;
   

    // try to reset timer  before returning
    TryResetMenuTimer('ShowModal');

    //popupWindosIds
    return uniquePopUpWindow;
}
function DestroyKendoWidgets() {
    //Needed to destroy Listbox control from Assignments. Kendo window (modal) destroy is not able to find Listbox instance so providing a manual destroy here
    if ($("#AvailableSelections") != null) {
        var avail = $("#AvailableSelections").data("kendoListBox");
        if (avail != null)
            avail.destroy();
    }
    if ($("#AssignedSelections") != null) {
        var assn = $("#AssignedSelections").data("kendoListBox");
        if (assn != null)
            assn.destroy();
    }
}

function ClosePopUpWindow(){
    DestroyKendoWidgets();
    $("#popupWindow").data("kendoWindow").close(); 
}

function Popup_Activate(arg, popupWindow, centerWindow, onActvateCallback) {
    Popup_Resize(arg, popupWindow, true, centerWindow);
    if (onActvateCallback && typeof (onActvateCallback) == "function")
        onActvateCallback(arg, popupWindow);
}

function Popup_Resize(arg, popupWindow, resizeOnActivation, centerWindow) {
    if (resizeOnActivation == null || resizeOnActivation == undefined || typeof (resizeOnActivation) != "boolean")
        resizeOnActivation = false;
    if (centerWindow == null || centerWindow == undefined || typeof (centerWindow) != "boolean")
        centerWindow = true;

    if ($(".popupMessage").length > 0) {
        var popupWindowHeight = ($(".popupWindowParent").length > 0) ? $(".popupWindowParent").height() : $("#popupWindow").height();
        var offset = ($(".popupWindowParent").length > 0) ? ($(".popupWindowParent .k-window-titlebar").offset().top - $(".popupWindowParent").offset().top) : 0;
        var buttonsAndTitleHeight = ($(".popupWindowParent").length > 0) ? ($(".popupWindowParent .btn-panel-right").innerHeight() + $(".popupWindowParent .k-window-titlebar").height() - offset) :
            ($("#popupWindow .btn-panel-right").innerHeight());
        var newPopupContainerHeight = popupWindowHeight - buttonsAndTitleHeight;
        if ($(".popupMessage").find("div[id$='_RepGridContainerDiv']").length == 1) {
            var gridContainer = $("#" + $(".popupMessage").find("div[id$='_RepGridContainerDiv']")[0].id);
            if (!gridContainer)
                return;

            var gridName = gridContainer.find(".k-grid")[0].id;
            //check that the window doesn't become higher than the container
            var availableHeight = 0;
            if ($("#ReportPageContainerId").length > 0) {
                availableHeight = $("#ReportPageContainerId").height() - 60;
            }
            else if ($("#divMain").length > 0) {
                availableHeight = $("#divMain").height() + $(".footer").height();//footer
            }

            if (availableHeight > 0 && availableHeight < popupWindowHeight) {
                popupWindowHeight = availableHeight;
            }

            var newReportPopupContainerHeight = popupWindowHeight - buttonsAndTitleHeight;
            if (typeof (Popup_Resize_CustomResizeForGrid) == "function") {
                Popup_Resize_CustomResizeForGrid(gridContainer, gridName, resizeOnActivation, newPopupContainerHeight, newReportPopupContainerHeight);
            }
            else {
                Popup_Resize_CustomResizeForGrid_Generic(gridContainer, gridName, resizeOnActivation, newPopupContainerHeight, newReportPopupContainerHeight, 5);
            }            
        }
        else if ($(".popupResizableContainer").length > 0) {
            $(".popupMessage").height(newPopupContainerHeight + (($(".popupWindowParent").length > 0) ? 3 : 0));
        }
    }

    if (resizeOnActivation && centerWindow)
        popUpWindow.center();
}


function Popup_Resize_CustomResizeForGrid_Generic(gridContainer, gridName, resizeOnActivation, newPopupContainerHeight, newReportPopupContainerHeight, offsetY) {
    newReportPopupContainerHeight += offsetY;
    if ($(".popupMessage").length > 0 && $(".popupMessage").parent().find(".dialogFooter").length > 0)//if we have buttons, we have to move them too
        $(".popupMessage").height((resizeOnActivation ? newReportPopupContainerHeight : newPopupContainerHeight) + 3);   
    gridContainer.height(newReportPopupContainerHeight);    
    ReportingGrid_ResizeGrid(gridName);//we'll ask grid to resize itself
    ReportingGrid_ResizeLastColumnToFillTheGridIfResizingDefined(gridName);
}

$(window).resize(function () {
    if (popUpWindow != null)
        popUpWindow.center();
    SizePanel();
    RepositionNotesPanel();
    ResizeCrfFormContainer();
});


function GetPopUpWidth() {
    var windowHeight = $(window).height();
    var windowWidth = $(window).width();

    if (windowHeight < windowWidth)
        return windowWidth * 0.3;
    else
        return windowWidth * 0.5;
}

$(document).ready(CommonDocumentReady);

function CommonDocumentReady() {
    var isDirty = SsoRemoveUrlParamWithSingleDigitValueAndCheckIfEqualToOne("isdrt");
    if (isDirty != undefined)
        sessionStorage.IsFormDirty = isDirty;
    SizePanel();
}

//Best to test by going to User Notifications and expanding Custom Notifications and resizing the window
function SizePanel() {
    var windowHeight = $(window).height();
    var panel = $("#mainPanel");
    if (panel.length > 0) {
        var panelBody = $("#mainPanelBody");
        var panelContent = $("#mainPanelContent");
        var panelBottom = panel.offset().top + panel.outerHeight(true);
        var pageBottomMargin = 40 + $("footer").height();
        var mainPanelBodyMargin = 36; //panelBodyMargin has a margin of 15
        var footerButtonsHeight = 0;
        var saveCancelDiv = $(".pageSaveCancel");
        if (saveCancelDiv.length > 0)
            footerButtonsHeight = saveCancelDiv.height();
        if (panelBottom + footerButtonsHeight + $("footer").height() > windowHeight) { //when panel content goes beyond window height
            var newPanelBodyHeight = windowHeight - panel.offset().top - panel.height() - pageBottomMargin - footerButtonsHeight + panelBody.height();
            panelBody.height(newPanelBodyHeight);
        }
        else if (panelContent.height() + mainPanelBodyMargin > panelBody.height()) { //when resizing window or expanding content larger and panelBody has room to exapnd to fit the content without a scrollbar
            while (panelContent.height() + mainPanelBodyMargin > panelBody.height() && !(panelBottom + footerButtonsHeight + pageBottomMargin > windowHeight)) {
                panelBody.height(panelBody.height() + mainPanelBodyMargin / 2);
                panelBottom = panel.offset().top + panel.outerHeight(true);
            }
        }
        else if (panelContent.height() < panelBody.height()) { //when content decreased in size for example by hiding/colapsing some content make panelBody size fit the content with its margin
            panelBody.height(panelContent.height() + mainPanelBodyMargin);
        }
    }
}

function ResizeGridsIfExists() {
    if (typeof (ReportingGrid_ResizeAllReportingGrids) == "function")
        ReportingGrid_ResizeAllReportingGrids();
}

function HideAll(container) {
    var obj = '#' + container;
    $(obj).find('.alert-info').hide();
    $(obj).find('.alert-danger').hide();
    $(obj).find('.alert-warning').hide();
    $(obj).find('.alert-success').hide();
}
function showInfo(message, container) {
    var obj = '#' + container;
    if ($(obj).length == 0) {
        showAlert(message);
        return;
    }
    $(obj).find('.spninfo').html(message);
    $(obj).find('.ulinfo').hide();
    HideAll(container);
    $(obj).find('.alert-info').show();
    ResizeGridsIfExists();
}
function showMultipleInfoMsg(message, multimessasge, container) {
    var obj = '#' + container;
    $(obj).find('.spninfo').html(message);
    $(obj).find('.ulinfo').show();
    $(obj).find('.ulinfo').html(multimessasge);
    HideAll(container);
    $(obj).find('.alert-info').show();
    ResizeGridsIfExists();
}
function showError(message, container) {
    var obj = '#' + container;
    if ($(obj).length == 0) {
        showAlert(message);
        return;
    }
    $(obj).find('.spnerror').html(message);
    $(obj).find('.ulerror').hide();
    HideAll(container);
    $(obj).find('.alert-danger').show();
    ResizeGridsIfExists();
}
function showMultipleErrorMsg(message, multimessasge, container) {
    var obj = '#' + container;
    $(obj).find('.spnerror').html(message);
    $(obj).find('.ulerror').show();
    $(obj).find('.ulerror').html(multimessasge);
    HideAll(container);
    $(obj).find('.alert-danger').show();
    ResizeGridsIfExists();
}
function showWarning(message, container) {
    var obj = '#' + container;
    if ($(obj).length == 0) {
        showAlert(message);
        return;
    }
    $(obj).find('.spnwarning').html(message);
    $(obj).find('.ulwarning').hide();
    HideAll(container);
    $(obj).find('.alert-warning').show();
    ResizeGridsIfExists();
}
function showMultipleWarning(message, multimessasge, container) {
    var obj = '#' + container;
    $(obj).find('.spnwarning').html(message);
    $(obj).find('.ulwarning').show();
    $(obj).find('.ulwarning').html(multimessasge);
    HideAll(container);
    $(obj).find('.alert-warning').show();
    ResizeGridsIfExists();
}
function showSuccess(message, container) {
    var obj = '#' + container;
    if ($(obj).length == 0) {
        showAlert(message);
        return;
    }
    $(obj).find('.spnsuccess').html(message);
    $(obj).find('.ulsuccess').hide();
    HideAll(container);
    $(obj).find('.alert-success').show();
    ResizeGridsIfExists();
}
function showMultipleSuccess(message, multimessasge, container) {
    var obj = '#' + container;
    $(obj).find('.spnsuccess').html(message);
    $(obj).find('.ulsuccess').show();
    $(obj).find('.ulsuccess').html(multimessasge);
    HideAll(container);
    $(obj).find('.alert-success').show();
    ResizeGridsIfExists();
}

var notespanelWindow;

function ShowManualQueriesView(titleText, link, TrlObjectId, TrlObjectFormId, InstanceNo, SecAreaId) {
    var npAction = 0/*None*/;
    ShowNotesPanel(titleText, link, TrlObjectId, TrlObjectFormId, InstanceNo, SecAreaId, 1, npAction, GetDefaultExtendedValues());
}
function ShowByPassView(titleText, link, TrlObjectId, TrlObjectFormId, InstanceNo, SecAreaId, extValues) {
    var npAction = 2/*AddBypassNote*/;
    ShowNotesPanel(titleText, link, TrlObjectId, TrlObjectFormId, InstanceNo, SecAreaId, 1, npAction, extValues);
}
function ShowChangeHistoryViewAddChangeNoteShowChangeHistoryView(titleText, link, TrlObjectId, TrlObjectFormId, SecAreaId) {
    var npAction = 0/*None*/;
    ShowNotesPanel(titleText, link, TrlObjectId, TrlObjectFormId, InstanceNo, SecAreaId, 3, npAction, GetDefaultExtendedValues());
}
function AddChangeNoteShowChangeHistoryView(titleText, link, TrlObjectId, TrlObjectFormId, SecAreaId) {
    var npAction = 1;/*AddChangeNote*/
    var InstanceNo = -1;
    ShowNotesPanel(titleText, link, TrlObjectId, TrlObjectFormId, InstanceNo, SecAreaId, 3, npAction, GetDefaultExtendedValues());
}
function DeleteGroupInstanceShowChangeHistoryView(titleText, link, TrlObjectId, TrlObjectFormId, InstanceNo, npAction, SecAreaId) {
    ShowNotesPanel(titleText, link, TrlObjectId, TrlObjectFormId, InstanceNo, SecAreaId, 3, npAction, GetDefaultExtendedValues());
}
function ShowGeneralNotesView(titleText, link, TrlObjectId, TrlObjectFormId, InstanceNo, SecAreaId) {
    var npAction = 0/*None*/;
    ShowNotesPanel(titleText, link, TrlObjectId, TrlObjectFormId, InstanceNo, SecAreaId, 2, npAction, GetDefaultExtendedValues());
}
function ShowAttachment(link, trlObjectId, trlObjectFormId, viewOnly) {
    var request = $.ajax({
        url: link,
        data:{
                toid:trlObjectId,
                tofid:trlObjectFormId,
                vo:viewOnly     
             },
        cache: false,
        method: "Get",
        success: function (html) {        	
        	var upID = ShowModal(html);        	
        	if (html.indexOf("IsDispositionAttachment") != -1) { // close popup imemdiatley -> file will be downloaded anyway
        		setTimeout(function () { CloseModelPopup(); }, 1000);        		
        	}
        },
        error: function (result) {
            alert("Attach Ajax error " + result);
        }
    }); 
}

function DisplayQuery(TrlObjectQueryId, TrlObjectFormId, title, actionUrl, secAreaId) {
    var npAction = 5/*None*/;
    ShowNotesPanel(HtmlDecode(title), decodeURIComponent(actionUrl), TrlObjectQueryId, TrlObjectFormId, 0, secAreaId, 1, npAction, GetDefaultExtendedValues());
}

/**
 * Show NotesPanel
 * @param {any} titleText
 * @param {any} link
 * @param {any} TrlObjectId
 * @param {any} TrlObjectFormId
 * @param {any} InstanceNo
 * @param {any} SecAreaId
 * @param {any} NotesTabSelector
 * @param {any} npAction
 * @param {any} extValues - Json objects with properties, all new property should be added to this object to avoid change existing JavaScript functions
 */
function ShowNotesPanel(titleText, link, TrlObjectId, TrlObjectFormId, InstanceNo, SecAreaId, NotesTabSelector, npAction, extValues) {
    var ht =getNotesPanelHeight();

    if ($("#NotesPanelWindow").length > 0)
        return;

    var toeid = 0;
    var pvid = 0;
    if (extValues != null && extValues != undefined && (extValues.TrlObjectEditId != null && extValues.PropertyValidationTypeId != null )) {
        toeid = extValues.TrlObjectEditId;
        pvid = extValues.PropertyValidationTypeId;
    }

    notespanelWindow = $("<div id='NotesPanelWindow'></div>")
    .appendTo("body")
    .kendoWindow({
            height: ht,
            position: {top: 70},
            modal: true,
            title : titleText,
            draggable : false,
            visible : false,
            resizable: false,
            animation: {
                    open : {
                                effects: "slideIn:left fadeIn",
                                duration: 100
                           },
                    close: {
                                effects: "slideIn:left fadeIn",
                                reverse: true,
                                duration: 100
                           }
            }, refresh: function () {
                var dialogTitle = $(this.content()).find(".dialogOptions").attr("title");
                if (titleText == "")
                    titleText = dialogTitle;
                notespanelWindow.title(HtmlDecode(titleText));
                Kendo_ShowOrHideLoadingImage("NotesPanelWindow", false);
            },
            close: function (e) {
                        this.destroy();
                  }
    }).data('kendoWindow').open();

    Kendo_ShowOrHideLoadingImage("NotesPanelWindow", true);

        notespanelWindow.refresh({
            url: link, data: {
            toid : TrlObjectId,
            tof: TrlObjectFormId,
            inst: InstanceNo,
            said: SecAreaId,
            stab: NotesTabSelector,
            npAction: npAction,
            toeid: toeid,
            pvid: pvid
            }
        });

    $('#NotesPanelWindow').parent().addClass("popupWindowParent").find('.k-i-close').first().addClass('fa fa-times-circle tmfatimescircle').text("");
    $('#NotesPanelWindow').parent().addClass("NotesPanelLayout");
    $('#NotesPanelWindow').addClass("NotesPanelContent");
    return notespanelWindow;
}

/**
 * Create a Default ExtendedObject with null values
 */
function GetDefaultExtendedValues() {
    return { TrlObjectEditId: null, PropertyValidationTypeId: null};
}

/**
 * Create an ExtendedObject populated with the parameter values
 * @param {any} trlObjectEditId
 * @param {any} propertyValidationTypeId
 */
function GetExtendedValuesObj(trlObjectEditId, propertyValidationTypeId) {
    return { TrlObjectEditId: trlObjectEditId, PropertyValidationTypeId: propertyValidationTypeId };
}

function CloseNotesPanel(updateValidationResults) {
    
    var notesPanel = $("#NotesPanelWindow").data("kendoWindow");
    if(notesPanel != undefined)
        notesPanel.close();

    if (updateValidationResults) 
        RefreshValidationsModalPopup();
    
}

function RefreshValidationsModalPopup() {
    var modalPopup = $("#ValidationsMPId");
    if (!modalPopup)
        return;

    var ajaxUrl = modalPopup.find("#ajaxUrl").val();
    var uniquePopUpWindow = $("#ValidationsMPId").data('kendoWindow');
    if(uniquePopUpWindow != undefined)
    {
        uniquePopUpWindow.refresh({
        url: ajaxUrl
        });
    }
}

function RepositionNotesPanel() {
    var ht = getNotesPanelHeight();
    var notespanel = $("#NotesPanelWindow").data("kendoWindow");
    if (notespanel != null) {
        notespanel.setOptions({
            height: ht,
            position: {
                top: 70,
                right: 0
            }
        });
        $('#NotesPanelWindow').parent().addClass("popupWindowParent").find('.k-i-close').first().addClass('fa fa-times-circle tmfatimescircle').text("");
    }
}

/**
 * Calculate and return the Height of NotesPanel
 */
function getNotesPanelHeight() {
    //70 from position top. This should be fixed since top navigation will be constant and 49 is Padding top added by Kendo
    return $(window).height() - (70 + 49);

}

function ReapplyValidatorsOnAddingPartialView() {
    $('form').removeData('validator');
    $('form').removeData('unobtrusiveValidation');
    $.validator.unobtrusive.parse('form');
}

function Kendo_ShowOrHideLoadingImage(divElementId, showLoadImage) {
    try {
        if (kendo != undefined && divElementId != undefined && divElementId != null && divElementId != "")
            kendo.ui.progress($("#" + divElementId), showLoadImage);
    }
    catch (err) {
    }
}


function RenderHtmlIntoControl(html, controlId, slowTransition) {
    if (slowTransition == null || slowTransition == undefined || typeof (slowTransition) != "boolean")
        slowTransition = true;//default
    if (slowTransition) {
        $("#" + controlId).css("visibility", "visible");//reduce flickering
        $("#" + controlId).css("display", "none");//reduce flickering
    }
    $("#" + controlId).empty().html(html);//render
    if (slowTransition)
        $("#" + controlId).fadeIn(350);//reduce flickering
}

function GlobalNavigation_RefreshCurrentPatient(fromCache, selectFormId, selectProFormId, selectFormInstanceNo, selectSecAreaId) {
    var patientLi = $("#NavBarPatientNavigation").find("li[id^='Patient_']");
    if (patientLi.length != 1)
        return;

    var ctrlRefreshCurrentPatient = fromCache ?
        $("#NavBarPatientNavigation").find("input[id='RefreshCurrentPatientFromCache']") :
        $("#NavBarPatientNavigation").find("a[id='RefreshCurrentPatientFromDb']");

    if (selectFormId && !isNaN(selectFormId) && selectFormId > 0 && (typeof panelSelection_CurrentExpandedInfo_RenderedForm != "undefined")) {
        panelSelection_CurrentExpandedInfo_RenderedForm = { Id: selectFormId, ProFormId: selectProFormId, FormInstanceNo: selectFormInstanceNo, SecAreaId: selectSecAreaId };
        if (typeof panelSelection_RestoreNextPatient != "undefined") {
            if (panelSelection_RestoreNextPatient != null) {
                if (typeof panelSelection_RestoreNextPatient.RenderedProFormId != "undefined") {
                    panelSelection_RestoreNextPatient.RenderedFormId = selectFormId;
                    panelSelection_RestoreNextPatient.RenderedProFormId = selectProFormId;
                    panelSelection_RestoreNextPatient.RenderedFormInstanceNo = selectFormInstanceNo;
                    panelSelection_RestoreNextPatient.RenderedSecAreaId = selectSecAreaId;
                }
            }
        }
    }

    if (ctrlRefreshCurrentPatient.length != 1)
        return;

    ctrlRefreshCurrentPatient.click();//this will call GlobalHeaderLeft_RefreshPatient
}


//use Url.Action("zzzACTzzz", "zzzCONTzzz") to create currentPathControllerAction
function UpdateNavigationOnSave(currentPathControllerAction, selectFormId) {
    var isPanelVisibleAndPatientSelected = ($("#divPanelSelection").length > 0 && $("#divPanelSelection").is(":visible") && $("#NavBarPatientNavigation").length > 0);
    if (!isPanelVisibleAndPatientSelected)
        return;//navigation panel not visible or patient not selected

    var patientLi = $("#NavBarPatientNavigation").find("li[id^='Patient_']");
    if (patientLi.length != 1)
        return;
    var trlObjectPatientId = patientLi.attr("id").replace('Patient_', '');
    var ajaxUrl = currentPathControllerAction.replace("zzzACTzzz", "UpdateNavigationOnSave").replace("zzzCONTzzz", "Navigation");
    var formNotSpecified = (selectFormId == null || selectFormId == undefined || isNaN(selectFormId) || selectFormId == 0);
    var postData = formNotSpecified ? { trlObjectPatientId: trlObjectPatientId } : { trlObjectPatientId: trlObjectPatientId, selFormId: selectFormId };

    Kendo_ShowOrHideLoadingImage("divMain", true);
    var ajaxErrorMessage = "Failed to refresh Navigation panel";

    $.ajax({
        url: ajaxUrl,
        method: "POST",
        data: postData,
        success: function (result) {
            Kendo_ShowOrHideLoadingImage("divMain", false);
            if (AjaxResult_CommonResultHandled(result))
                return; 
            if (result.result == "OK") {
                if (formNotSpecified)
                    GlobalNavigation_RefreshCurrentPatient(true);
                else
                    GlobalNavigation_RefreshCurrentPatient(true, selectFormId, result.proFormId, result.formInstanceNo, result.secAreaId);
            }
            else if (result.result == "ERROR") {
                ReportGridAjax_ErrorHandler(ajaxErrorMessage, result);
            }
        },
        error: function (result) {
            Kendo_ShowOrHideLoadingImage("divMain", false);
            ReportGridAjax_ErrorHandler(ajaxErrorMessage, result);
        }
    });
    PanelSelection_OnResize();
}


function GetEfFectiveWidth() {
    var mainWidth = $('#rootCrf').width();
    var wid = '';
    if (mainWidth > 1199) {
        wid = mainWidth * 0.25;
    }
    if (mainWidth > 991 && mainWidth < 1200) {
        wid = mainWidth * 0.33;
    }
    if (mainWidth > 767 && mainWidth < 992) {
        wid = mainWidth * 0.5;
    }
    if (mainWidth < 768) {
        wid = mainWidth * 1;
    }
    return wid;
}

function Global_getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function Global_setCookie(cname, cvalue, exdays) {
    if (!isNaN(exdays) || exdays == null || exdays < 1)
        document.cookie = cname + "=" + cvalue;
    else {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
}

function ResizeCrfFormContainer() {
    if (window.ShareCRFForm && window.ShareCRFForm != undefined)
        window.ShareCRFForm.UpdateStateOnResize();
}



    function FilterSelection(inputCntrl, optionsCntrl) {
        var filterTxt = inputCntrl.val().toLowerCase();
        if (filterTxt.length < 3) {
            optionsCntrl.each(function () {
                $(this).show();
            });
        }
        else {
            optionsCntrl.each(function () {
                if ($(this).text().toLowerCase().indexOf(filterTxt) == 0)
                    $(this).show();
                else
                    $(this).hide();
            });
        }
    }


//when this function returns false, caller should proceed with custom result handling, otherwise (when returns true) it should not continue with the result processing
//ajaxResult should have the following properties:
//1) result: (string) result code (e.g. 'ERR_PER')
//2) message: (string) display message (if null or empty, it will not display the popup message)
//3) logout: (bool) when true, it will call logout (if popup is displayed, it will logout after popup is closed)
//4) redirectUrl: (string) with URL where user will be redirected (if popup is displayed, it will redirect after popup is closed). logout must be 'false'.
//5) responseText: OPTIONAL (string) containing message details
function AjaxResult_CommonResultHandled(ajaxResult) {
    if (ajaxResult == null || ajaxResult == undefined || ajaxResult.result == null || ajaxResult.result == undefined ||
        (ajaxResult.result != "ERR_PER" && ajaxResult.result != "ERR_6" && ajaxResult.result != "ERR_8")) //6-offline; 8-locked
        return false;

    if (ajaxResult.result == "ERR_6" || ajaxResult.result == "ERR_8") {
        var logoutReason = (ajaxResult.result == "ERR_6") ? 6 : 8;
        Global_CancelAndLogOutWithError(ajaxResult.currentUrlTemplate, logoutReason, ajaxResult.errorMessage, ajaxResult.trialGroupName);
        return true;
    }

    var doLogout = (ajaxResult.logout != null && ajaxResult.logout != undefined && typeof (ajaxResult.logout) == "boolean") ? ajaxResult.logout : false;
    var redirectUrl = (ajaxResult.redirectUrl != null && ajaxResult.redirectUrl != undefined) ? ajaxResult.redirectUrl : "";
    var onFinish = function () {
        if (doLogout)
            Logout();
        else if (redirectUrl != "")
            window.location.replace(redirectUrl);
    };

    if (ajaxResult.message == undefined || ajaxResult.message == null || ajaxResult.message == "") {
        //no popup
        onFinish();
    }
    else {
        //show popup
        ReportGridAjax_ErrorHandler(ajaxResult.message, ajaxResult, onFinish);
    }
    return true;
}

//use Url.Action("zzzACTzzz", "zzzCONTzzz") to create currentPathControllerAction
function Global_CancelAndLogOutWithError(currentPathControllerAction, logoutReason, errorMessage, trialGroupName) {
    if (logoutReason == 0)
        return;//no logout requested
    var ajaxUrl = currentPathControllerAction.replace("zzzACTzzz", "CancelAndLogOutWithError").replace("zzzCONTzzz", "Account");
    var loginUrl = currentPathControllerAction.replace("zzzACTzzz", "Login").replace("zzzCONTzzz", "Account");
    if (window.top.location.href.toLowerCase().indexOf(loginUrl.toLowerCase()) >= 0)
        return;//we're already logged out
    $.ajax({
        data: { logoutReason: logoutReason, errorMessage: errorMessage },
        url: ajaxUrl,
        method: "POST",
        success: function (result) {
            window.top.location.href = (loginUrl + "?tgn=" + encodeURIComponent(HtmlDecode(trialGroupName)) + "&errorMessage=" + encodeURIComponent(HtmlDecode(errorMessage)));
        },
        error: function (result) {
            showAlert("Ajax error navigating away", "Error");
        }
    });
}


function ReportGridAjax_ErrorHandler(message, result, onPopupClose) {
    var errorMessage = ReportGridAjax_GetErrorHandlerMessage(message, result);
    if (errorMessage)
        showErrorPU(errorMessage, "Error", onPopupClose);
}

function ReportGridAjax_GetErrorHandlerMessage(message, result) {
    if (message && result) {
        var additionalText = "";// && result.responseText
        if (result.responseText) {
            if (!result.responseText.toUpperCase().startsWith("<!DOCTYPE HTML>"))
                additionalText = result.responseText;
            else {
                //sometimes unhanded exceptions will return the whole error page - we cannot have that when displaying error in pop-up
                var detErrorIdx = result.responseText.toUpperCase().indexOf('<SPAN CLASS="SPNERROR">');//extract error message from page
                if (detErrorIdx > 0) {
                    var detErrorEndIdx = result.responseText.toUpperCase().indexOf('</SPAN>', detErrorIdx + 23);
                    if (detErrorEndIdx > detErrorIdx)
                        additionalText = result.responseText.substring(detErrorIdx + 23, detErrorEndIdx).trim();                    
                }
            }
        }
        else if ($.type(result) === "string")
            additionalText = result;
        //result.responseText might be enclosed with header and warning style - remove it
        if (additionalText != "") {
            var msgDetails = additionalText.replace("<h1 ", "<p ").replace("<h2 ", "<p ").replace("<h3 ", "<p ").replace("</h1>", "</p>").replace("</h2>", "</p>").replace("</h3>", "</p>");
            message += "<br/><br/><i>Details:</i><br/>" + msgDetails;
        }
    }
    return message;
}


//use Url.Action("zzzACTzzz", "zzzCONTzzz") to create currentPathControllerAction
function SafetyLink_OpenCreateDowngradePopup(currentPathControllerAction, saeEditCheckValueIsSae, trlObjectFormId, saeTerm, saeFullDateUserFormatted, saeFullDateUnformatted) {
    var ajaxUrl = currentPathControllerAction.replace("zzzACTzzz", "OpenCreateDowngradePopup").replace("zzzCONTzzz", "SafetyLinkAct");
    $.ajax({
        url: ajaxUrl,
        method: "GET",
        data: { trlObjectFormId: trlObjectFormId, isSae: saeEditCheckValueIsSae, saeTerm: saeTerm, saeFullDateUserFormatted: saeFullDateUserFormatted, saeFullDateUnformatted: saeFullDateUnformatted },
        success: function (html) {
            ShowModal(html, false, false, null, null, true);//, saeEditCheckValueIsSae ? null : SafetyLink_InitiateCaseDowngrade)
        },
        error: function (result) {
            showAlert("Failed to open SafetyLink create/downgrade popup window", "Error");
        }
    });
}
function ResetPDEForm(){
  if (window.ShareCRFForm && window.ShareCRFForm != undefined)
        window.ShareCRFForm.ResetPDEForm();
}

function LoadIcrf(icrfHref) {
    Kendo_ShowOrHideLoadingImage("divMain", true);
    window.location = icrfHref;
}

function BackToAllVisits(gridName, controller, uniqueGridId) {
    eval($("tr[onclick^='PanelSelection_OnAllVisitsClick']").attr("onclick"));
}
function BackToAllForms() {
    eval($("tr[onclick^='PanelSelection_OnAllFormsClick']").attr("onclick"));
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
function processOnFocus(element) {
    var isMobile = $(window).width() < 450 ? true : false;
    if (isMobile)
        $('.footer').hide();
    var container = document.getElementById('divBodyRender');
    container.scrollTop = element.offsetTop - 50;
}
function processOnBlur() {
    var isMobile = $(window).width() < 450 ? true : false;
    if (isMobile)
        $('.footer').show();
}

function processOnBlurTG() {
    processOnBlur();

    $('#txtTrialGroupName').val($('#txtTrialGroupName').val().trim());
}

function TgroupFocus() {
    var element = document.getElementById('txtTrialGroupName');
    processOnFocus(element);
}

function UnameFocus() {
    var element = document.getElementById('txtUsername');
    processOnFocus(element);
}
function PwdFocus() {
    var element = document.getElementById('Password');
    processOnFocus(element);   
}

function SsoRemoveUrlParamWithSingleDigitValueAndCheckIfEqualToOne(paramName) {
    var parVal = SsoRemoveUrlParamAndGetValue(paramName);
    if (parVal != undefined)
        return (parVal == '1');
    return parVal;
}

function SsoRemoveUrlParamAndGetValue(paramName) {
    var nPos = -1;
    if (window.location.search)
        nPos = window.location.search.toLowerCase().indexOf(paramName.toLowerCase() + "=");
    if (nPos > -1) {
        var nxtPar = window.location.search.indexOf("&", nPos);
        if (nxtPar < 0)
            nxtPar = window.location.search.length;
        var chVal = window.location.search.substring(nPos + paramName.length + 1, nxtPar);
        var href = window.location.pathname + window.location.search;
        var replTxt = paramName + "=" + chVal;
        href = href.replace('&' + replTxt, '');
        href = href.replace('?' + replTxt + '&', '?');//if there are other params
        href = href.replace('?' + replTxt, '');//if this is the only param
        window.history.replaceState({}, document.title, href);
        return chVal;
    }
    return undefined;
}

function AuditReportHeightAdjustment(tabContent) {
    var contentHeight = ($(window).height() * 0.9) * 0.80;
    var tabContentObj = $(tabContent);
    if (tabContentObj !== undefined && contentHeight !== undefined) {
        tabContentObj.each(function () {
            $(this).height(contentHeight + "px");
        });
    }
}